import { TextButton } from '@buoyhealth/common.buoy-button';
import { HelpfulQuestion } from '@buoy-components/user-feedback';
import Grid from '@mui/material/Grid';
import { Fragment } from 'react';
import styled from 'styled-components';
import { trackStructuredEvent } from 'src/analytics';
import usePolarisActor from 'src/hooks/usePolarisActor';
import { getCategory } from '../../analytics';
import RichEndings from '../Completion/components/RichEndings';
import useInterview from '../../hooks/useInterview';
import CollapsibleResults from '../CollapsibleResults';
import TypewriterResults from '../TypewriterResults';
import useCompletion from './hooks/useCompletion';
import { lowerCaseString } from './questions';
import CondensedProductCards from 'src/interviews/components/CondensedProductCards';

import type { IMiniInterviewProps } from 'src/packages/polaris/types/';

const StyledTextButton = styled(TextButton)`
  font-size: 16px;
  text-decoration: underline;
`;

const Completion = ({
  handleGoBack,
  polarisProps,
}: {
  conditionName: string;
  handleGoBack: () => void;
  polarisProps?: IMiniInterviewProps['polarisProps'];
  slug: string;
}) => {
  const state = usePolarisActor()?.getSnapshot();
  const completion = useCompletion();
  const interview = useInterview();

  const symptomName = state?.context.conditionName;

  const sections = completion.results
    ? completion.results.treatment.sections.map((section) => {
        return {
          ...section,
          products: section.products.map((product) => {
            return {
              ...product,
              affiliate_url: product.url,
              image_url: product.url_image,
              name: product.title,
              ratings_count: product.reviews_count,
            };
          }),
        };
      })
    : [];
  const Container = polarisProps ? CollapsibleResults : Fragment;
  return (
    <Grid item>
      <Container isShowingResults={!!completion.results}>
        {!!completion.results ? (
          <>
            <Grid item className="bp-pb-6">
              <StyledTextButton onClick={handleGoBack}>
                {'< Back to all treatment types'}
              </StyledTextButton>
            </Grid>

            <div className="bp-font-primary-small bp-pb-6">
              {completion.results?.treatment.intro}
            </div>
            {sections.map((result: any) => (
              <div className=" bp-pb-6">
                <div className="bp-font-primary-small"> {result.header}</div>
                <div className="bp-font-secondary-small bp-pb-6 last:bp-pb-0">
                  {' '}
                  {result.summary}
                </div>
                {result.products.length > 0 ? (
                  <CondensedProductCards
                    products={result.products}
                    moduleLocation="treatment-eoi"
                  />
                ) : null}{' '}
              </div>
            ))}
            <div>
              <HelpfulQuestion
                snowplowProps={{
                  action: getCategory('treatment'),
                  label: interview.token || '',
                }}
                trackingCallback={trackStructuredEvent}
                withBuoyTheme
              />
            </div>
            {symptomName && !!completion.results && (
              <RichEndings interviewType="treatment" query={symptomName} />
            )}
          </>
        ) : (
          <TypewriterResults dx="" results={''} sx={lowerCaseString(symptomName)} />
        )}
      </Container>
    </Grid>
  );
};

export default Completion;
